import store from 'src/store'
import { actions as accountActions } from 'src/store/modules/account/actions'
import { getSession } from 'src/services/session'

const APP_AUTH_ROUTES = ['/login', '/callback']

let isRedirecting = false

export const redirectToAppLogin = () => {
  if (isRedirecting) return
  if (APP_AUTH_ROUTES.includes(window.location.pathname)) return

  isRedirecting = true

  // The session is gone: step out of presence before the page goes away (bounded, never blocks).
  // Imported lazily on purpose: this module sits under the axios response interceptor, and a
  // static import would close the cycle interceptors → unauthorized → presence → realtime → http
  import('src/services/presence')
    .then(({ presenceService }) => presenceService.stop())
    .catch(console.debug)
    .finally(() => window.location.assign('/login'))
}

export const redirectToOauthReLogin = () => {
  if (isRedirecting) return

  const state = store.getState() as {
    account: {
      data: {
        oauthClients: { id: string; redirectUris: string[] }[]
      }
    }
  }
  const firstClient = state.account.data.oauthClients[0]
  const session = getSession()

  if (!firstClient) {
    redirectToAppLogin()

    return
  }

  isRedirecting = true

  store.dispatch(
    accountActions.getOauthAuthorize({
      clientId: firstClient.id,
      redirectUri: firstClient.redirectUris[0],
      state: 'test-state-' + Date.now(),
      token: session.accessToken,
    })
  )
}

export const handleUnauthorized = () => {
  const session = getSession()

  if (session.accessToken) {
    redirectToOauthReLogin()

    return
  }

  redirectToAppLogin()
}
